module.exports = __webpack_public_path__ + "img/ug.065ffa66.svg";